module.exports = __webpack_public_path__ + "img/twitter_icon.223ff999.svg";